<template>
  <m4-card
    :class="classes"
    :border-variant="borderVariant"
    :bg-variant="bgVariant"
    :disabled="disabled"
    :icon="icon"
    :icon-variant="iconVariant"
    :icon-variant-bigger="iconVariantBigger"
    :link="link"
    v-bind="$attrs"
  >
    <div v-if="rightCornerText" class="box__right-corner">
      <div class="box__right-corner__triangle">
        <div class="box__right-corner__triangle__text">
          {{ rightCornerText }}
        </div>
      </div>
    </div>
    <m4-level class="box__header" no-wrap>
      <m4-level-left>
        <div @click="$emit('clickOnTitle')">
          <m4-heading :level="level">
            {{ title }}
            <slot name="title"></slot>
          </m4-heading>
          <div v-if="subtitle" class="box__subtitle">
            <m4-icon v-if="subtitleIcon" :icon="subtitleIcon"></m4-icon>
            {{ subtitle }}
          </div>
        </div>
      </m4-level-left>
      <m4-level-right v-if="hasRightTopSlot">
        <div><slot name="righttop"></slot></div>
      </m4-level-right>
    </m4-level>
    <div class="box__body" v-if="hasBodySlot">
      <slot></slot>
    </div>
    <div class="box__footer" v-if="hasFooterSlot">
      <slot name="footer"></slot>
    </div>
    <div class="box__under-footer" v-if="hasUnderFooterSlot">
      <slot name="underfooter"></slot>
    </div>
  </m4-card>
</template>

<script>
export default {
  name: "M4Box",
  props: {
    title: {
      type: String
    },
    level: {
      type: String,
      default() {
        return "3";
      }
    },
    subtitle: {
      type: String
    },
    subtitleBold: {
      type: Boolean,
      default() {
        return false;
      }
    },
    subtitleIcon: {
      type: String
    },
    paddingSize: {
      type: String
    },
    bodyBg: {
      type: Boolean,
      default() {
        return false;
      }
    },
    leftBorderVariant: {
      type: String
    },
    rightCornerText: {
      type: String
    },
    borderVariant: {
      type: String
    },
    bgVariant: {
      type: String
    },
    link: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    iconVariant: {
      type: String,
      default() {
        return "primary";
      }
    },
    iconVariantBigger: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  emits: ["clickOnTitle"],
  computed: {
    classes() {
      let classes = ["box"];

      if (!this.title) {
        classes.push("box--only-body");
      }

      if (this.subtitleBold) {
        classes.push("box--subtitle-bold");
      }

      if (this.paddingSize) {
        classes.push("box--padding-" + this.paddingSize);
      }

      if (this.bodyBg) {
        classes.push("box--body-bg");
      }

      if (this.rightCornerText) {
        classes.push("box--right-corner-text");
      }

      if (this.leftBorderVariant) {
        classes.push("box--left-border-" + this.leftBorderVariant);
      }

      if (this.hasUnderFooterSlot) {
        classes.push("box--has-under-footer");
      }

      if (!this.hasBodySlot) {
        classes.push("box--no-body-slot");
      }

      classes.push("box--title-level-" + this.level);

      return classes;
    },
    hasBodySlot() {
      return typeof this.$slots.default === "function";
    },
    hasRightTopSlot() {
      return typeof this.$slots.righttop === "function";
    },
    hasFooterSlot() {
      return typeof this.$slots.footer === "function";
    },
    hasUnderFooterSlot() {
      return typeof this.$slots.underfooter === "function";
    }
  }
};
</script>
